import type { Contact } from '@nutralab/api';
import type { Brand } from '@nutralab/ui/brand';

import { getContacts } from './getContacts';

import { ContactType } from '@/shared/constants';

const SCHEMA_CONTEXT = 'https://schema.org';

interface BuildSiteJsonLdParams {
    origin: string;
    brand: Brand;
    contacts: Contact[];
}

export function buildSiteJsonLd({ origin, brand, contacts }: BuildSiteJsonLdParams): object {
    const organization: Record<string, unknown> = {
        '@type': 'Organization',
        '@id': `${origin}#organization`,
        name: brand.name,
        url: origin,
        logo: `${origin}${brand.logo.full}`,
    };

    const contactMap = getContacts(contacts);
    const phone = contactMap[ContactType.PHONE];
    const email = contactMap[ContactType.EMAIL];

    if (phone || email) {
        organization.contactPoint = {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            ...(phone && { telephone: phone }),
            ...(email && { email }),
        };
    }

    return {
        '@context': SCHEMA_CONTEXT,
        '@graph': [
            organization,
            {
                '@type': 'WebSite',
                '@id': `${origin}#website`,
                name: brand.name,
                url: origin,
                publisher: { '@id': `${origin}#organization` },
            },
        ],
    };
}
